import React from 'react';
import {
  Box,
  Select,
  MenuItem,
  Typography,
  Chip,
  FormControl
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { format } from 'date-fns';

const VersionSelector = ({ 
  versions, 
  currentVersionIndex, 
  onVersionChange,
  disabled = false
}) => {
  if (!versions || versions.length === 0) {
    return null;
  }

  const handleChange = (event) => {
    const newIndex = parseInt(event.target.value, 10);
    if (onVersionChange) {
      onVersionChange(newIndex);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <Select
          value={currentVersionIndex}
          onChange={handleChange}
          disabled={disabled}
          displayEmpty
          sx={{
            fontSize: '14px',
            '& .MuiSelect-select': {
              py: 0.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#4759694d'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#475969'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#485869',
              borderWidth: '1px'
            }
          }}
        >
          {versions.map((version, index) => (
            <MenuItem key={version.id} value={index}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                <Typography variant="body2" sx={{ fontSize: '14px' }}>
                  {version.isPreview ? version.label : `Version ${version.versionNumber}`}
                </Typography>
                {index === versions.length - 1 && !version.isPreview && (
                  <Chip 
                    label="Latest" 
                    size="small" 
                    sx={{ 
                      height: 18,
                      fontSize: '11px',
                      bgcolor: '#e3f2fd',
                      color: '#1976d2'
                    }}
                  />
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {versions[currentVersionIndex] && !versions[currentVersionIndex].isPreview && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: '#6b7280',
            fontSize: '12px',
            ml: 1
          }}
        >
          {format(new Date(versions[currentVersionIndex].timestamp), 'MMM d, h:mm a')}
        </Typography>
      )}
    </Box>
  );
};

export default VersionSelector;